import type React from 'react'

export const IconGhost: React.FC<{ width?: number }> = ({ width }) => (
  <svg
    width={width || 17}
    height={width || 16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7 6.49976H4.3C3.5268 6.49976 2.9 7.17133 2.9 7.99976C2.9 8.82818 3.5268 9.49976 4.3 9.49976H12.7C13.4732 9.49976 14.1 8.82818 14.1 7.99976C14.1 7.17133 13.4732 6.49976 12.7 6.49976ZM4.3 4.99976C2.7536 4.99976 1.5 6.3429 1.5 7.99976C1.5 9.65661 2.7536 10.9998 4.3 10.9998H12.7C14.2464 10.9998 15.5 9.65661 15.5 7.99976C15.5 6.3429 14.2464 4.99976 12.7 4.99976H4.3Z"
      fill="currentColor"
    />
  </svg>
)
